let Main = () => import('../components/Main.vue');
let Login = () => import('../components/pages/Login.vue');
let Home = () => import('../components/pages/Home.vue');
let Error404 = () => import('../components/pages/errors/Error404.vue');

// Management
// User
let Management = () => import('../components/pages/management/Index.vue');
let Permission = () => import('../components/pages/management/Permission.vue');
let Role = () => import('../components/pages/management/Role.vue');
let User = () => import('../components/pages/management/User.vue');
let Announcement = () => import('../components/pages/management/Announcement.vue');

// Activity Logs
let ActivityLogs = () => import('../components/pages/activity-logs/Index.vue');
let TableActivityLogs = () => import('../components/pages/activity-logs/Table.vue');

// Sales Agent
let Agents = () => import('../components/pages/agents/Index.vue');
let TableAgents = () => import('../components/pages/agents/Table.vue');
let LogsAgent = () => import('../components/pages/agents/Logs.vue');
let MapAgent = () => import('../components/pages/agents/Map.vue');
let CoveragePlanAgent = () => import('../components/pages/agents/Coverage.vue');
let ExpensesAgent = () => import('../components/pages/agents/Expenses.vue');

// Engineer
let EngineersTable = () => import('../components/pages/engineer/Table.vue');

// IT
let itTable = () => import('../components/pages/it/Table.vue');

// New account
let NewAccount = () => import('../components/pages/new-accounts/Index.vue');
let TableNewAccount = () => import('../components/pages/new-accounts/Table.vue');

// Prospect
let Prospect = () => import('../components/pages/prospect/Index.vue');
let TableProspect = () => import('../components/pages/prospect/Table.vue');

// Expenses
let Maintenance = () => import('../components/pages/maintenance/Index');
let MExpenses = () => import('../components/pages/maintenance/MExpenses');

const routes = [
    {
        path: '/login',
        name: "login",
        component: Login,
        meta: {
            title: 'Login',
            requiresAuth: false
        },
    },
    {
        path: '*',
        name: 'error404',
        component: Error404,
        meta: {
            title: 'Error 404',
            requiresAuth: false,
        },
    },
    {
        path: "",
        redirect: {name: 'home'},
        component: Main,
        children: [
            {
                path: '/home',
                name: 'home',
                component: Home,
                meta: {
                    title: 'Home',
                    requiresAuth: true,
                }
            },
            {
                path: "/maintenance",
                name: 'maintenance',
                component: Maintenance,
                redirect: {name: 'MExpenses'},
                children: [
                    {
                        path: "/maintenance/MExpenses",
                        name: 'MExpenses',
                        component: MExpenses,
                        meta: {
                            title: 'Expenses List',
                            requiresAuth: true,
                        }
                    }
                ]
            },
            {
                path: "/management",
                name: 'management',
                redirect: {name: 'users'},
                component: Management,
                children: [
                    {
                        path: '/management/permissions',
                        name: 'permissions',
                        component: Permission,
                        meta: {
                            title: 'Permissions',
                            requiresAuth: true
                        }
                    },
                    {
                        path: '/management/roles',
                        name: 'roles',
                        component: Role,
                        meta: {
                            title: 'Roles',
                            requiresAuth: true
                        }
                    },
                    {
                        path: '/management/users',
                        name: 'users',
                        component: User,
                        meta: {
                            title: 'Users',
                            requiresAuth: true
                        }
                    },
                    {
                        path: '/management/announcements',
                        name: 'announcements',
                        component: Announcement,
                        meta: {
                            title: 'Announcements',
                            requiresAuth: true
                        }
                    },
                ]
            },
            {
                path: '/activity-logs',
                name: 'activityLogs',
                redirect: {name: 'activityLogsTable'},
                component: ActivityLogs,
                children: [
                    {
                        path: '/',
                        name: 'activityLogsTable',
                        component: TableActivityLogs,
                        meta: {
                            title: 'Activity Logs',
                            requiresAuth: true
                        }
                    }
                ]
            },
            {
                path: '/agents',
                name: 'agents',
                redirect: {name: 'agentsTable'},
                component: Agents,
                children: [
                    {
                        path: '/',
                        name: 'agentsTable',
                        component: TableAgents,
                        meta: {
                            title: 'Sales Agents',
                            requiresAuth: true
                        }
                    },
                    {
                        path: 'agent-logs/:id',
                        name: 'agentsLogs',
                        component: LogsAgent,
                        meta: {
                            title: 'Agent Logs',
                            requiresAuth: true
                        }
                    },
                    {
                        path: 'agent-map/:id/:scope/:counter',
                        name: 'agentMap',
                        component: MapAgent,
                        meta: {
                            title: 'Agent Map',
                            requiresAuth: true
                        }
                    },
                    {
                        path: 'coverage-plans/:id',
                        name: 'coveragePlans',
                        component: CoveragePlanAgent,
                        meta: {
                            title: 'Coverage Plans',
                            requiresAuth: true
                        }
                    },
                    {
                        path: 'expenses/:id',
                        name: 'expenses',
                        component: ExpensesAgent,
                        meta: {
                            title: 'Expenses',
                            requiresAuth: true
                        }
                    },
                ]
            },
            {
                path: '/engineers',
                name: 'engineers',
                redirect: {name: 'engineersTable'},
                component: Agents,
                children: [
                    {
                        path: '/',
                        name: 'engineersTable',
                        component: EngineersTable,
                        meta: {
                            title: 'Engineers',
                            requiresAuth: true
                        }
                    },
                    {
                        path: 'engineer-logs/:id',
                        name: 'engineersLogs',
                        component: LogsAgent,
                        meta: {
                            title: 'Engineer Logs',
                            requiresAuth: true
                        }
                    },
                ]
            },
            {
                path: '/it',
                name: 'it',
                redirect: {name: 'itTable'},
                component: Agents,
                children: [
                    {
                        path: '/',
                        name: 'itTable',
                        component: itTable,
                        meta: {
                            title: 'ITs',
                            requiresAuth: true
                        }
                    },
                    {
                        path: 'it-logs/:id',
                        name: 'itLogs',
                        component: LogsAgent,
                        meta: {
                            title: 'IT Logs',
                            requiresAuth: true
                        }
                    },
                ]
            },
            {
                path: '/new-account',
                name: 'newAccount',
                redirect: {name: 'newAccountTable'},
                component: NewAccount,
                children: [
                    {
                        path: '/',
                        name: 'newAccountTable',
                        component: TableNewAccount,
                        meta: {
                            title: 'New Account',
                            requiresAuth: true
                        }
                    }
                ]
            },
            {
                path: '/prospect',
                name: 'prospect',
                redirect: {name: 'prospectTable'},
                component: Prospect,
                children: [
                    {
                        path: '/',
                        name: 'prospectTable',
                        component: TableProspect,
                        meta: {
                            title: 'Prospect',
                            requiresAuth: true
                        }
                    }
                ]
            },
        ],
    }
];

export default routes;
